import { filter, orderBy, take } from 'lodash'

const checkEntryValue = (str) => {
	if (str) {
		return str.toLowerCase()
			.replace(new RegExp('\\s', 'g'), '')
			.replace(new RegExp('[àáâãäå]', 'g'), 'a')
			.replace(new RegExp('æ', 'g'), 'ae')
			.replace(new RegExp('ç', 'g'), 'c')
			.replace(new RegExp('[èéêë]', 'g'), 'e')
			.replace(new RegExp('[ìíîï]', 'g'), 'i')
			.replace(new RegExp('ñ', 'g'), 'n')
			.replace(new RegExp('[òóôõö]', 'g'), 'o')
			.replace(new RegExp('œ', 'g'), 'oe')
			.replace(new RegExp('[ùúûü]', 'g'), 'u')
			.replace(new RegExp('[ýÿ]', 'g'), 'y')
			.replace(new RegExp('\\W', 'g'), '')
	}
	return str
}
const getResult = (list, nbResult) => {
	if (nbResult) {
		return take(orderBy(list, ['name'], ['asc']), nbResult)
	}
	return orderBy(list, ['name'], ['asc'])
}
const filterList = (list, filterInput, nbResult = 0) => {
	if (filterInput) {
		const formatFilterInput = checkEntryValue(filterInput)
		return getResult(filter(list, (o) => {
			return (o.nameResearch ? o.nameResearch.includes(formatFilterInput) : false) ||
				(o.codeResearch ? o.codeResearch.includes(formatFilterInput) : false) ||
				(o.postalCodeResearch ? o.postalCodeResearch.includes(formatFilterInput) : false)
		}), nbResult)
	}
	return getResult(list, nbResult)
}

export { filterList, getResult, checkEntryValue }



// WEBPACK FOOTER //
// ./src/utils/FilterUtils.js